import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { PaperBase } from '../PaperBase';
import { navigationRailStyles } from './NavigationRail.styles';
import { navigationRailTheme } from './NavigationRail.stylex';
import { NavigationRailDestination } from '../NavigationRailDestination';
const NavigationRail = forwardRef(function NavigationRail(props, forwardedRef) {
    const { styles, sx, children, header, footer, groupAlignment = 'center', divider, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'NavigationRail',
        styles: [navigationRailStyles, styles],
    });
    return (_jsxs(PaperBase, { ...other, sx: [
            globalStyles,
            navigationRailTheme,
            combineStyles('host', divider && 'host$divider'),
            sx,
        ], ref: forwardedRef, children: [header ? _jsx("div", { ...getStyles('header'), children: header }) : null, _jsx("div", { ...getStyles('group', `group$${groupAlignment}`), children: children }), footer ? _jsx("div", { ...getStyles('footer'), children: footer }) : null] }));
});
const NavigationRailNamespace = Object.assign(NavigationRail, {
    Destination: NavigationRailDestination,
});
export { NavigationRailNamespace as NavigationRail };
